export default __webpack_public_path__ + "733c9557a8c116154c1b12f3946ea422.svg";